import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useIntl } from 'react-intl';
import { authorizedLogout } from '../actions';
import { AUTHORIZED_MODULE } from '../../../configs/moduleNames';
import { responseLogWithNotification } from '../../../utils/utils';

export default function LogoutPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authorized = useSelector(state => state[AUTHORIZED_MODULE]);
  const { formatMessage } = useIntl();
  const { loggedIn } = authorized;
  useEffect(() => {
    if (!loggedIn) {
      navigate('/');
    } else {
      dispatch(authorizedLogout())
        .then(() => {
          navigate('/');
        })
        .catch(response => {
          responseLogWithNotification(response, formatMessage({ id: 'app.logout' }), formatMessage({ id: 'error.default' }));
        });
    }
  }, [navigate]);

  return null;
}
